<template>
    <div class="form glass-element">
      <h2>Owned and preferred games</h2>
      <ItemsListProfile title="Owned" list="owned" />
      <v-divider></v-divider>
      <ItemsListProfile title="Preferred" list="preferred" />
      <v-divider></v-divider>
    </div>

</template>

<script>
import ItemsListProfile from "@/components/atoms/ItemsListProfile";

export default {
  components: { ItemsListProfile },
  data() {
    return {
      loading: false,
    };
  },
};
</script>
